import { Group, Text, Button, Box, Grid, ActionIcon, Flex, Modal, Input, Table, Radio,Select, Skeleton } from '@mantine/core';
import { IconWorld, IconHelp, IconTrash, IconPencil, IconX, IconCheck, IconCaretUpFilled, IconCaretDownFilled, IconSearch, IconCode, IconSettings, IconUnlink } from '@tabler/icons-react';
import { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import ReactDOM from 'react-dom';
import { modals } from '@mantine/modals';
import { VisiLoader, SelectTooltip, useColorScheme } from "../../GeneralComponent/GeneralComponent";
import { useAuth } from '../../../AuthContext';
import { notifications } from '@mantine/notifications';
import PermissionWrapper from '../../../PermissionWrapper';
import SettingsApi from "../../../api/SettingsApi";
import './ShopifyCard.css';
import { UniversalSmartCodeModal } from './UniversalSmartCodeModal';
import { DomainFlickerSettings } from './DomainFlickerSettings';

export function ManageYourDomains({ SelectMemberWebsiteListValue, SelectMemberWebsiteListOnChange, RefreshDataFromChild }:any) {

  const navigate = useNavigate();
  const { setWebsiteListData } = useAuth();

  const [addDomainOpened, setAddDomain] = useState(false);

  const [addSubdomainOpened, setAddSubdomain] = useState(false);

  const [subdomainVisiSmartCode, setSubdomainVisiSmartCode] = useState(false);
  const [visiSmartCodeModalOpen, setVisiSmartCodeModalOpen] = useState(false);
  const [visiSmartCodeWebsiteId, setVisiSmartCodeWebsiteId] = useState('');
  const [visiSmartCodeSubdomainId, setVisiSmartCodeSubdomainId] = useState('');
  const [visiSmartCodeWebsiteUrl, setVisiSmartCodeWebsiteUrl] = useState('');

  /*const [PublishDomainChecked, PublishDomainSetChecked] = useState(false);*/

  const [GetDomainListLoader, setGetDomainListLoader] = useState(false);

  const [DeleteDomainLoader, setDeleteDomainLoader] = useState(false);

  const [AddDomainLoader, setAddDomainLoader] = useState(false);
  const [getSingleDomainLoader, setGetSingleDomainLoader] = useState(false);
  const [getSubDomainListLoader, setGetSubDomainListLoader] = useState(false);

  const [DomainList, setDomainList] = useState([]);

  const [WebsiteName, setWebsiteName] = useState('');
  const [WebsiteAddress, setWebsiteAddress] = useState('');
  const [FrontendFramework, setFrontendFramework] = useState('0');
  const [selectedFrameworkType, setSelectedFrameworkType] = useState("1");
  const [Protocol, setProtocol] = useState('ftp');
  const [Host, setHost] = useState('');
  const [Port, setPort] = useState('');
  const [Username, setUsername] = useState('');
  const [Password, setPassword] = useState('');
  const [DefaultRootDirectory, setDefaultRootDirectory] = useState('/');

  const manageDomainIconRef = useRef(null);
  const addDomainIconRef = useRef(null);
  const addSubdomainIconRef = useRef(null);
  const HTMLPHPRef = useRef(null);
  const frontendframworkRef = useRef(null);
  const ghlRef = useRef(null);
  const shopifyRef = useRef(null);
  const wordpressRef = useRef(null);
  const emdashRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({});

  const [sortKeyName, setSortKeyName] = useState('');
  const [sortingDirection, setSortingDirection] = useState('');
  const [sortedDomainList, setSortedDomainList] = useState([]);

  const [shopifyLoading, setShopifyLoading] = useState(false);
  const [shopifyStatusLoading, setShopifyStatusLoading] = useState(false);
  const [shopifyToken, setShopifyToken] = useState('');
  const [flickerSettingsModelOpen, setFlickerSettingsModelOpen] = useState(false);
  const [flickerSettingsWebsiteId, setFlickerSettingsWebsiteId] = useState("");
  const [subdomainFrontendFramework, setSubdomainFrontendFramework] = useState('0');
  const [subdomainSelectedFrameworkType, setSubdomainSelectedFrameworkType] = useState("1");
  // 2-step subdomain modal that mirrors the website modal:
  //   step 'subdomain'        -> form: pick framework, enter name, click Add
  //   step 'shopify_connect'  -> only the "Connect Shopify Store" CTA
  const [subdomainModalStep, setSubdomainModalStep] = useState<'subdomain' | 'shopify_connect'>('subdomain');
  // Edit mode for the subdomain modal. When subdomainEditId is non-empty, the
  // modal renders the form pre-filled from that row's data and the submit
  // handler hits the 'update' action instead of 'save'. The connected flag
  // gates the type radio so the user can't change subdomain_type out from
  // under an active Shopify install.
  const [subdomainEditId, setSubdomainEditId] = useState('');
  const [subdomainEditShopifyConnected, setSubdomainEditShopifyConnected] = useState(false);
  
  const colorTheme = useColorScheme();

  // Shopify OAuth state
  const [shopifyConnected, setShopifyConnected] = useState(false);
  const [shopifyNeedsReauth, setShopifyNeedsReauth] = useState(false);
  const [shopifyShopInput, setShopifyShopInput] = useState('');
  const [shopifySiteListLoader, setShopifySiteListLoader] = useState(false);
  const [, setShopifySiteOptions] = useState<any[]>([]);
  const [, setSelectedShopifySiteId] = useState('');
  const [domainModalStep, setDomainModalStep] = useState('domain');

  const [updateDomainId, setUpdateDomainId] = useState('');
  const [shopifyShop, setShopifyShop] = useState("");
  // Post-OAuth subdomain picker -- mirror of the website-level Shopify
  // modal (shopifyModalOpen + selectedWebsite + selectDomainList) but
  // for the subdomain flow. After Shopify redirects back, if the user
  // started the OAuth from a subdomain row we open this modal so they
  // can confirm or retarget the connection at the subdomain level.
  const [shopifySubdomainModalOpen, setShopifySubdomainModalOpen] = useState(false);
  const [selectedSubdomainTarget, setSelectedSubdomainTarget]     = useState('');
  const [shopifySubdomainOptions, setShopifySubdomainOptions]     = useState<any[]>([]);
  const [shopifySubdomainListLoader] = useState(false);

  const [shopifyConnectDomainId, setShopifyConnectDomainId] = useState('');
  const [shopifyConnectSubDomainId, setShopifyConnectSubDomainId] = useState('');

/*  const handlePublishDomainChange = (event:any) => {
    PublishDomainSetChecked(event.currentTarget.checked);
  };*/

  const [publishToValue, publishToSetValue] = useState('1');

  const handleRefreshDataFromChild = (websiteId) => {
    RefreshDataFromChild(websiteId);
  };

  // Check Shopify OAuth connection status for a website
  const checkShopifyStatus = (websiteId: string) => {
    if (!websiteId) return;
    setShopifyStatusLoading(true);
    SettingsApi.getshopifyoauthstatus({
      system_website_id: websiteId
    })
    .then((response: any) => response.json())
    .then((data: any) => {
      if (data.status === 1) {
        setShopifyConnected(data.data.connected);
        setShopifyNeedsReauth(data.data.shopify_status === 'requires_reauthorization');
        if (data.data.shop_domain) {
          setShopifyShopInput(data.data.shop_domain);
        } else {
          setShopifyShopInput('');
        }
      }
      setShopifyStatusLoading(false);
    })
    .catch(() => {
      setShopifyStatusLoading(false);
    });
  };
  
  // Shopify Disconnect handler
  const executeShopifyDisconnect = () => {
    if (!updateDomainId) return;
    setShopifyLoading(true);
    SettingsApi.disconnectshopify({
      system_website_id: updateDomainId
    })
    .then((response: any) => response.json())
    .then((data: any) => {
      if (data.status === 1) {
        setShopifyConnected(false);
        setShopifyNeedsReauth(false);
        setShopifyShopInput('');
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: 'Shopify disconnected successfully.',
        });
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message || 'Failed to disconnect Shopify.',
        });
      }
      setShopifyLoading(false);
    })
    .catch(() => {
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: 'Failed to connect to server.',
      });
      setShopifyLoading(false);
    });
  };

  // Handle Shopify OAuth redirect URL params on mount.
  //
  // Two branches, distinguished by which sentinel was dropped into
  // localStorage just before the user was sent to Shopify:
  //   - shopify_pending_subdomain_id  -> subdomain flow: open the
  //                                       subdomain picker, default-
  //                                       selected to the originating
  //                                       subdomain. The dropdown lists
  //                                       all subdomains under the same
  //                                       parent website.
  //   - shopify_pending_site_id (or neither) -> website flow: open the
  //                                       existing website picker.
  // The previous auto-connect-to-subdomain behaviour is gone -- the
  // user always gets the chance to confirm or retarget after OAuth,
  // matching the website flow.

  // Submit the subdomain Shopify popup -- mirrors handleShopifyStore but
  // saves at the subdomain level. The selected subdomain id is sent as
  // domain_subdomain_id, which connect_shopify_store routes to the
  // website_domain row instead of the website row.
  const handleShopifySubdomainConnect = () => {
    if (!selectedSubdomainTarget) {
      notifications.show({
        color: "red",
        title: "Error",
        message: "Please select a subdomain.",
      });
      return;
    }
    setShopifyLoading(true);
    SettingsApi.connectshopifystore({
      domain_subdomain_id: selectedSubdomainTarget,
      shopify_access_token: shopifyToken,
      shopify_store_name: shopifyShop,
    })
    .then((response: any) => {
      if (response.ok) return response.json();
      if (response.status === 401 || response.status === 400) navigate("/logout");
    })
    .then((data: any) => {
      if (data && data.status === 1) {
        notifications.show({
          color: "green",
          icon: <IconCheck size="1.1rem" />,
          title: "Success",
          message: data.message || "Shopify store connected to subdomain successfully.",
        });
        setShopifySubdomainModalOpen(false);
        setSelectedSubdomainTarget('');
        setShopifySubdomainOptions([]);
        setShopifyToken('');
        setShopifyShop('');
        // Clean any leftover OAuth params (defensive -- already cleaned
        // in the useEffect, but a refresh-then-resubmit case is possible).
        const url = new URL(window.location.href);
        url.searchParams.delete('shopify_connected');
        url.searchParams.delete('token');
        url.searchParams.delete('shop');
        window.history.replaceState({}, '', url.toString());
      } else {
        notifications.show({
          color: "red",
          icon: <IconX size="1.1rem" />,
          title: "Error",
          message: (data && data.message) || "Failed to save Shopify connection.",
        });
      }
    })
    .catch(() => {
      notifications.show({
        color: "red",
        icon: <IconX size="1.1rem" />,
        title: "Error",
        message: "Failed to connect to server.",
      });
    })
    .finally(() => {
      setShopifyLoading(false);
    });
  };

  const loadShopifySiteList = (savedSiteId: string) => {
    setShopifySiteListLoader(true);
    SettingsApi.getdomainlist()
    .then((response: any) => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setShopifySiteListLoader(false);
          navigate("/logout");
        }
      }
    })
    .then((data: any) => {
      const siteOptions = (data?.data || []).map((item: any) => ({
        value: item.website_id,
        label: item.website_name,
      }));
      setShopifySiteOptions(siteOptions);
      if (siteOptions.some((item: any) => item.value === savedSiteId)) {
        setSelectedShopifySiteId(savedSiteId);
      } else if (siteOptions.length > 0) {
        setSelectedShopifySiteId(siteOptions[0].value);
      } else {
        setSelectedShopifySiteId('');
      }
      setShopifySiteListLoader(false);
      setDomainModalStep('shopify_connect');
    })
    .catch(() => {
      setShopifySiteListLoader(false);
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: 'Failed to fetch site list.',
      });
    });
  };

  const handleConnectShopifyStore = () => {
    const apiBaseUrl = process.env.REACT_APP_BACKEND_API_BASE_URL || '';
    const hostname = new URL(apiBaseUrl).hostname;
    const cookieDomain =
      '.' + hostname.split('.').slice(-2).join('.');
    document.cookie = `shopifyConnectDomainId=${shopifyConnectDomainId}; domain=${cookieDomain}; path=/; max-age=3600; Secure; SameSite=None`;
    document.cookie = `shopifyDomainType=main; path=/; domain=${cookieDomain}; max-age=3600; Secure; SameSite=None`;
    const url = process.env.REACT_APP_SHOPIFY_INSTALL_URL;
    if (!url) {
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: 'Shopify install URL is not configured.',
      });
      return;
    }
    window.location.href = url;
  };

  // Subdomain "Connect Shopify Store" button handler.
  //
  // Mirrors the website Shopify connect flow but at the subdomain level.
  // We persist two things to localStorage so the post-OAuth useEffect
  // can rebuild the subdomain picker after the page reload:
  //   - shopify_pending_subdomain_id          -> default selection
  //   - shopify_pending_subdomain_website_id  -> parent site, used to
  //                                              fetch the subdomain
  //                                              dropdown contents
  // (Stale website sentinel is cleared so the OAuth return can't get
  // mis-routed into the website branch.)
  const handleSubdomainConnectShopify = () => {
    const apiBaseUrl = process.env.REACT_APP_BACKEND_API_BASE_URL || '';
    const hostname = new URL(apiBaseUrl).hostname;
    const cookieDomain =
      '.' + hostname.split('.').slice(-2).join('.');
    document.cookie = `shopifyConnectDomainId=${shopifyConnectSubDomainId}; domain=${cookieDomain}; path=/; max-age=3600; Secure; SameSite=None`;
    document.cookie = `shopifyDomainType=sub; path=/; domain=${cookieDomain}; max-age=3600; Secure; SameSite=None`;
    const url = process.env.REACT_APP_SHOPIFY_INSTALL_URL;
    if (!url) {
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: 'Shopify install URL is not configured.',
      });
      return;
    }
    window.location.href = url;
  };

  const handleAddDomainSubmit = (event:any, proceedToShopify: boolean = false) => {
    setAddDomainLoader(true);
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    let site_type = '0';
/*    if(PublishDomainChecked === true){
      if(publishToValue === '2'){
        site_type = '2';
      }else if(publishToValue === '3'){
        site_type = '3';
      }
    }*/
    SettingsApi.addeditdomain({
      site_type : site_type,
      site_name : WebsiteName,
      website_address : WebsiteAddress,
      front_end_framework : FrontendFramework,
      shopify_access_token : '',
      shopify_store_name : '',
      ftp_host : Host,
      ftp_port : Port,
      ftp_proto : Protocol,
      ftp_user : Username,
      ftp_pass : Password,
      ftp_default_root_dir : DefaultRootDirectory,
      website_id: updateDomainId ? updateDomainId : '',
      framework_type: selectedFrameworkType
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setAddDomainLoader(false);
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        const isShopifyFlow = FrontendFramework === '2';
        if(data.data && data.data.site_id){
          setShopifyConnectDomainId(data.data.site_id);
          if(updateDomainId){
            const updatedList = DomainList.map(item =>
              item.website_id === updateDomainId
                ? { ...item, website_name: WebsiteName }
                : item
            );
            setDomainList(updatedList);
            setSortedDomainList(updatedList);
          }else{
            setDomainList([...DomainList, {website_id : data.data.site_id, website_name : WebsiteName}]);
            setSortedDomainList([...DomainList, {website_id : data.data.site_id, website_name : WebsiteName}]);
          }
        }
        setAddDomainLoader(false);
        if (isShopifyFlow && proceedToShopify) {
          loadShopifySiteList(data?.data?.site_id ? data.data.site_id : updateDomainId);
        } else {
          closeDomainModal();
        }
        notifications.show({
          color: 'teal',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
        setWebsiteListData([]);
        handleRefreshDataFromChild('add__' + data.data.site_id);
        if (!updateDomainId && !(isShopifyFlow && proceedToShopify)) {
          setTimeout(() => {
            handleViewUniversalSmartCode(data.data.site_id, WebsiteAddress);
          }, 1000);
        }
      }else{
        setAddDomainLoader(false);
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        })
      }
    })
    .catch(error => {
      console.log(error);
      setAddDomainLoader(false);
    });
  };

  const [subdomainName, setSubdomainName] = useState('');

  // Open the subdomain modal in edit mode. Pulls the row from the backend
  // (so we always have the canonical type/framework/Shopify state), then
  // pre-fills the form. The is_shopify_connected flag drives the type
  // radio's "locked behind Disconnect" guard.
  const handleEditSubdomain = (id: any) => {
    setGetSubDomainListLoader(true);
    setAddSubdomain(true);
    setSubdomainModalStep('subdomain');
    setSubdomainEditId(id);
    SettingsApi.getsingledomainsubdomain({ domain_subdomain_id: id })
      .then((response: any) => {
        if (response.ok) return response.json();
        if (response.status === 401 || response.status === 400) {
          setGetSubDomainListLoader(false);
          navigate('/logout');
        }
      })
      .then((data: any) => {
        if (data && data.status === 1 && data.data) {
          setSubdomainName(data.data.domain_name || '');
          setSubdomainFrontendFramework(String(data.data.subdomain_type || '0'));
          setSubdomainSelectedFrameworkType(String(data.data.subdomain_frontend_framework || '1'));
          setSubdomainEditShopifyConnected(Number(data.data.is_shopify_connected) === 1);
        } else {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: (data && data.message) || 'Failed to load subdomain.',
          });
        }
        setGetSubDomainListLoader(false);
      })
      .catch(() => {
        setGetSubDomainListLoader(false);
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: 'Failed to reach the server.',
        });
      });
  };

  // Disconnect Shopify on a single subdomain row.
  //
  // The confirm modal stays open while the disconnect API is in flight:
  //   - closeOnConfirm:false stops Mantine's auto-close on confirm.
  //   - confirmProps.loading is flipped to true (and both buttons are
  //     disabled) for the duration of the request, so the user sees
  //     visible progress and can't double-click or cancel mid-flight.
  //   - Outside-click and Escape are also blocked so the modal can only
  //     dismiss after the API resolves (we close it manually).
  // On success we update the subdomain row in local state so the
  // Disconnect icon disappears immediately.
  // This Mantine version exposes neither a return id from openConfirmModal
  // nor modals.updateModal, so we can't drive the confirm button's loading
  // state from outside the modal. Instead, open a plain modal whose body
  // is an inline component that owns its own loading state and renders
  // both buttons. Toggling local useState rerenders the buttons in place.
  // closeOnClickOutside / closeOnEscape / withCloseButton are off so the
  // popup can only be dismissed via these buttons (which we disable while
  // the disconnect API is in flight).
  const handleSubdomainDisconnectShopify = (id: any, name: string) => {
    const modalId = 'disconnect-shopify-subdomain-' + String(id);

    const DisconnectBody: React.FC = () => {
      const [loading, setLoading] = useState(false);

      const handleConfirm = () => {
        setLoading(true);
        SettingsApi.disconnectshopify({ domain_subdomain_id: id })
          .then((response: any) => response.json())
          .then((data: any) => {
            if (data && data.status === 1) {
              notifications.show({
                color: 'teal',
                icon: <IconCheck size="1.1rem" />,
                title: 'Success',
                message: data.message || 'Shopify disconnected from subdomain.',
              });
              setSubdomainTableData(prev =>
                prev.map((row: any) =>
                  row.domain_subdomain_id === id
                    ? { ...row, is_shopify_connected: 0, shopify_store_name: '' }
                    : row
                )
              );
              modals.close(modalId);
            } else {
              setLoading(false);
              notifications.show({
                color: 'red',
                icon: <IconX size="1.1rem" />,
                title: 'Error',
                message: (data && data.message) || 'Failed to disconnect Shopify.',
              });
            }
          })
          .catch(() => {
            setLoading(false);
            notifications.show({
              color: 'red',
              icon: <IconX size="1.1rem" />,
              title: 'Error',
              message: 'Failed to reach the server.',
            });
          });
      };

      return (
        <>
          <Text size="sm">
            Are you sure you want to disconnect Shopify from <b>{name}</b>?
            This uninstalls the Visiopt app from your Shopify store.
          </Text>
          <Group position="right" mt="md" spacing="xs">
            <Button
              variant="default"
              disabled={loading}
              onClick={() => modals.close(modalId)}
            >
              Cancel
            </Button>
            <Button
              color="red"
              loading={loading}
              disabled={loading}
              onClick={handleConfirm}
            >
              Disconnect
            </Button>
          </Group>
        </>
      );
    };

    modals.open({
      modalId,
      trapFocus: false,
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
      title: 'Disconnect Shopify',
      children: <DisconnectBody />,
    });
  };

  const handleAddSubdomainSubmit = (event:any) => {
    event.preventDefault();
    // Two paths:
    //   - subdomainEditId set    -> 'update' action (rename + type change)
    //   - subdomainEditId empty  -> 'save'   action (create), unchanged
    // For Shopify-typed creates, after a successful save we still flip the
    // modal to the "Connect Shopify Store" step so the OAuth round-trip
    // can write the token/store back into the row via connect_shopify_store.
    const isShopifyFlow = subdomainFrontendFramework === '2';
    const isEdit        = subdomainEditId !== '';

    if (isEdit) {
      const editId = subdomainEditId;
      setShopifyConnectSubDomainId(editId);
      SettingsApi.adddeletedomainsubdomain({
        action_perform: 'update',
        domain_subdomain_id: editId,
        domain_name: subdomainName,
        domain_type: subdomainFrontendFramework,
        domain_frontend_framwork: subdomainSelectedFrameworkType,
      })
      .then((response: any) => {
        if (response.ok) return response.json();
        if (response.status === 401 || response.status === 400) navigate('/logout');
      })
      .then((data: any) => {
        if (data && data.status === 1) {
          // Reflect the edit locally without a full refetch -- keeps the
          // table in sync with what the user just saved.
          setSubdomainTableData(prev =>
            prev.map((row: any) =>
              row.domain_subdomain_id === editId
                ? {
                    ...row,
                    domain_name: subdomainName,
                    subdomain_type: subdomainFrontendFramework,
                    subdomain_frontend_framework: subdomainSelectedFrameworkType,
                  }
                : row
            )
          );
          notifications.show({
            color: 'teal',
            icon: <IconCheck size="1.1rem" />,
            title: 'Success',
            message: data.message || 'Subdomain updated.',
          });

          // If the row is now Shopify but isn't yet connected (either the
          // user just switched to Shopify, or it was already Shopify but
          // never finished OAuth), transition the modal to the
          // "Connect Shopify Store" step so the user can finish the
          // install. Mirrors what handleAddSubdomainSubmit does after a
          // successful create with isShopifyFlow.
          if (isShopifyFlow && !subdomainEditShopifyConnected) {
            setSubdomainEditId('');
            setSubdomainModalStep('shopify_connect');
          } else {
            closeSubdomainModal();
          }
        } else {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: (data && data.message) || 'Failed to update subdomain.',
          });
        }
      })
      .catch(() => {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: 'Failed to reach the server.',
        });
      });
      return;
    }

    SettingsApi.adddeletedomainsubdomain({
      website_id : websiteId,
      action_perform : "save",
      domain_name : subdomainName,
      domain_type: subdomainFrontendFramework,
      domain_frontend_framwork: subdomainSelectedFrameworkType,
      shopify_access_token: '',
      shopify_store_name: ''
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1 && data.data && data.data.website_sub_domain_id && data.data.website_sub_domain_id !== ""){
        const newSubdomainId = data.data.website_sub_domain_id;
        setShopifyConnectSubDomainId(newSubdomainId);
        const AddSubdomainData = {
          bg_color: '',
          domain_name: subdomainName,
          domain_subdomain_id: newSubdomainId,
          subdomain_type: subdomainFrontendFramework,
          subdomain_frontend_framework: subdomainSelectedFrameworkType,
          is_shopify_connected: 0,
        };
        setSubdomainTableData([...subdomainTableData, AddSubdomainData]);
        notifications.show({
          color: 'teal',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });

        if (isShopifyFlow) {
          // Switch the modal to step 2: just like website flow, only the
          // "Connect Shopify Store" CTA is shown next.
          setSubdomainModalStep('shopify_connect');
        } else {
          // Non-Shopify subdomain: existing behavior -- show the smart code.
          setSubdomainFrontendFramework('0');
          setSubdomainSelectedFrameworkType('1');
          handleViewUniversalSmartCode(websiteId, subdomainName, true, newSubdomainId);
          setSubdomainName('');
        }
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        setSubdomainName('');
      }
    })
    .catch(error => {
      console.log(error);
    });
  };

  

  const handleViewUniversalSmartCode = (websiteId: any, websiteUrl: string, isSubdomain : boolean = false, subdomainId: any = '') => {
    setVisiSmartCodeWebsiteId(websiteId);
    setVisiSmartCodeWebsiteUrl(websiteUrl);
    if(isSubdomain){
      setVisiSmartCodeSubdomainId(subdomainId);
    }
    setSubdomainVisiSmartCode(isSubdomain);
    setVisiSmartCodeModalOpen(true);
  };

  const handleFlickerSettings = (website_id: any) => {
    setFlickerSettingsModelOpen(true);
    setFlickerSettingsWebsiteId(website_id);
  };

  const handleFlickerSettingsClose = () => {
    setFlickerSettingsModelOpen(false);
    setFlickerSettingsWebsiteId("");
  };

  const handleCloseVisiSmartCodeModal = () => {
    setVisiSmartCodeModalOpen(false);
    setSubdomainVisiSmartCode(false);
    setVisiSmartCodeWebsiteId('');
    setVisiSmartCodeWebsiteUrl('');
  };

  const updateDomain = (id:any) => {
    setShopifyConnectDomainId(id);
    setUpdateDomainId(id);
    setDomainModalStep('domain');
    setAddDomain(true);
    setGetSingleDomainLoader(true);
    SettingsApi.getsingledomain({
      website_id: id
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setGetSingleDomainLoader(false);
          navigate('/logout');
        }
      }
    })
    .then((data) => {
      if (data.status === 1) {
        setProtocol(data.data.ftp_proto);
        setPort(data.data.ftp_port);
        setHost(data.data.ftp_host);
        setUsername(data.data.ftp_user);
        setPassword(data.data.ftp_pass);
        setWebsiteName(data.data.site_name);
        if (data.data.front_end_framework === '2') {
          setShopifyStatusLoading(true);
        }
        setFrontendFramework(data.data.front_end_framework);
        setWebsiteAddress(data.data.site);
        setDefaultRootDirectory(data.data.ftp_default_root_dir);
        // Check Shopify OAuth status if platform is Shopify
        if (data.data.front_end_framework === '2') {
          if (data.data.shopify_status === 'connected') {
            setShopifyConnected(true);
            setShopifyShopInput(data.data.shopify_store_name || '');
          } else {
            setShopifyConnected(false);
            setShopifyShopInput('');
          }
        }
        setSelectedFrameworkType(data.data.framework_type);
        /*PublishDomainSetChecked(true);*/
        if(data.data.domain_type && data.data.domain_type > 0){
          publishToSetValue(data.data.domain_type);
        }else{
          publishToSetValue('1');
        }
      }
      setGetSingleDomainLoader(false);
    })
    .catch((error) => {
      console.error('API Error:', error);
      setGetSingleDomainLoader(false);
    });
  }

  const closeDomainModal = () => {
    setAddDomain(false);
    setDomainModalStep('domain');
    setUpdateDomainId('');
    setProtocol('');
    setPort('');
    setHost('');
    setUsername('');
    setPassword('');
    setWebsiteName('');
    setShopifyConnected(false);
    setShopifyShopInput('');
    setShopifyLoading(false);
    setShopifyStatusLoading(false);
    setShopifySiteListLoader(false);
    setShopifySiteOptions([]);
    setSelectedShopifySiteId('');
    setFrontendFramework('0');
    setWebsiteAddress('');
    setDefaultRootDirectory('');
    /*PublishDomainSetChecked(false);*/
    publishToSetValue('1');
  }

  const [websiteId, setWebsiteId] = useState('');

  const closeSubdomainModal = () => {
    setAddSubdomain(false);
    setSubdomainName('');
    // Reset 2-step subdomain modal state so the next open starts clean.
    setSubdomainModalStep('subdomain');
    setSubdomainEditId('');
    setSubdomainEditShopifyConnected(false);
    setSubdomainFrontendFramework('0');
    setSubdomainSelectedFrameworkType('1');
  }

  const AddSubdomain = (id:any) => {
    setWebsiteId(id);
    setAddSubdomain(true);
    setGetSubDomainListLoader(true);
    setSubdomainFrontendFramework('0');
    setSubdomainSelectedFrameworkType('1');
    SettingsApi.getdomainsubdomainlist({
      website_id: id
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setGetSubDomainListLoader(false);
          navigate('/logout');
        }
      }
    })
    .then((data) => {
      if (data.status === 1) {
        setSubdomainTableData(data.data);
      }
      setGetSubDomainListLoader(false);
    })
    .catch((error) => {
      console.error('API Error:', error);
      setGetSubDomainListLoader(false);
    });
  }

  const [subdomainTableData, setSubdomainTableData] = useState([]);

  const deleteDomainConfirm = (deleteDomainId:any) => modals.openConfirmModal({
    trapFocus: false,
    title: 'Please confirm your action',
    children: (
      <Text size="sm">
        Are you sure you want to uninstall VisiOpt from this website?
      </Text>
    ),
    labels: { confirm: 'Confirm', cancel: 'Cancel' },
    onCancel: () => {},
    onConfirm: () => {
      setDeleteDomainLoader(true);
      SettingsApi.uninstalldomain({
        website_id : deleteDomainId,
        selected_site_id: SelectMemberWebsiteListValue
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            setDeleteDomainLoader(false);
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setDomainList(DomainList.filter(item => item.website_id !== deleteDomainId));
          setSortedDomainList(DomainList.filter(item => item.website_id !== deleteDomainId));
          setDeleteDomainLoader(false);
          notifications.show({
            color: 'teal',
            icon: <IconCheck size="1.1rem" />,
            title: 'Success',
            message: data.message,
          });
          setWebsiteListData([]);
          handleRefreshDataFromChild('delete__' + deleteDomainId);
        }else{
          setDeleteDomainLoader(false);
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          })
        }
      })
      .catch(error => {
        console.log(error);
        setDeleteDomainLoader(false);
      });
    }
  });

  const deleteSubdomainConfirm = (deleteSubdomainId:any, deleteSubDomainName:any) => modals.openConfirmModal({
    trapFocus: false,
    title: 'Please confirm your action',
    children: (
      <Text size="sm">
        Are you sure you want to uninstall VisiOpt from this website?
      </Text>
    ),
    labels: { confirm: 'Confirm', cancel: 'Cancel' },
    onCancel: () => console.log('Cancel'),
    onConfirm: () => handleSubdomainDelete(deleteSubdomainId,deleteSubDomainName),
  });

  const handleSubdomainDelete = (id:any,name:any) => {
    SettingsApi.adddeletedomainsubdomain({
      domain_subdomain_id : id,
      action_perform : "delete",
      domain_name : name
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setSubdomainTableData(subdomainTableData.filter(item => item.domain_subdomain_id !== id));
        notifications.show({
          color: 'teal',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        })
      }
    })
    .catch(error => {
      console.log(error);
    });
  };



  useEffect(() => {
    setGetDomainListLoader(true);
    SettingsApi.getdomainlist()
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setGetDomainListLoader(false);
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1 && data.data && data.data.length > 0){
        setDomainList(data.data);
        setSortedDomainList(data.data);
        setGetDomainListLoader(false);
      }
      setGetDomainListLoader(false);
    })
    .catch(error => {
      console.log(error);
      setGetDomainListLoader(false);
    });
  }, [navigate]);

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    const iconRefMapping = {
      172: manageDomainIconRef,
      126: addDomainIconRef,
      160: addSubdomainIconRef,
      364: HTMLPHPRef,
      365: frontendframworkRef,
      366: ghlRef,
      367: shopifyRef,
      368: wordpressRef,
      383: emdashRef,
    };
    const iconRef = iconRefMapping[id];
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        [id]: {top: rect.top + scrollOffset, left: rect.left + rect.width + 10 },
      });
    }
  };

  const checkAddDomain = () => {
    setGetDomainListLoader(true);
    SettingsApi.checkadddomain()
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setGetDomainListLoader(false);
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setDomainModalStep('domain');
        setAddDomain(true);
      }else{
        modals.open({
          title: 'Please correct the following errors:',
          children: (
          <>
            <Text size="sm" style={{ whiteSpace: "pre-line" }}>
              {data.message}
            </Text>
            <Group position="right" mt="sm">
              <Button onClick={() => modals.closeAll()}>OK</Button>
            </Group>
          </>
          ),
        });
      }
      setGetDomainListLoader(false);
    })
    .catch(error => {
      console.log(error);
      setGetDomainListLoader(false);
    });
  }

  useEffect(() => {
    if (addDomainOpened && FrontendFramework === '2' && updateDomainId) {
      checkShopifyStatus(updateDomainId);
    }
  }, [addDomainOpened, FrontendFramework, updateDomainId]);

  const handleSorting = (keyName: string) => {
    let newDirection = sortingDirection === 'desc' ? 'asc' : 'desc';
    setSortingDirection(newDirection);
    setSortKeyName(keyName);
    
    const sortedCampaignList = [...DomainList].sort((a, b) => {
      if (!keyName) return 0;

      const valueA = a[keyName]?.toString().toLowerCase() || '';
      const valueB = b[keyName]?.toString().toLowerCase() || '';

      if (valueA < valueB) return newDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return newDirection === 'asc' ? 1 : -1;
      return 0;
    });
    setSortedDomainList(sortedCampaignList);
  };

  const handleKeywordChange = (e) => {
    const keyword = e.target.value;

    const filteredList = DomainList.filter(data =>
      data.website_name?.toLowerCase().includes(keyword.toLowerCase())
    );

    setSortedDomainList(filteredList);
  };

	return (
		<>
      <VisiLoader VisiLoaderVisible={GetDomainListLoader} />
      <VisiLoader VisiLoaderVisible={DeleteDomainLoader} />
      {showHelpModal &&
        ReactDOM.createPortal(
          <div>
            {Object.keys(tooltipPosition).map((key) => (
              <SelectTooltip
                isVisible={showHelpModal}
                setIsVisible={setShowHelpModal}
                id={helpTargetId}
                tooltipPosition={tooltipPosition[key]} 
              />
            ))}
          </div>,
        document.body
      )}
      {/*
        Subdomain Shopify post-OAuth picker. Mirrors the website Shopify
        modal above, but the dropdown lists subdomains under the parent
        website and the Connect button writes the connection at the
        subdomain level. Default selection is the originating subdomain
        (the row whose Connect Shopify Store button started this OAuth).
      */}
      <Modal opened={shopifySubdomainModalOpen} onClose={() => setShopifySubdomainModalOpen(false)} centered size="md" radius="md" withCloseButton={false}>
        <VisiLoader VisiLoaderVisible={shopifySubdomainListLoader} />
        <div style={{ textAlign: "center", padding: "10px 5px" }}>
          <Text size="xl" fw={700} mb={6}>
            Connect Shopify Store
          </Text>
          <Text size="sm" c="dimmed" mb={20}>
            Select the subdomain you want to connect
          </Text>
          <Select
            placeholder="Select subdomain"
            data={shopifySubdomainOptions}
            value={selectedSubdomainTarget}
            onChange={(v) => setSelectedSubdomainTarget(v || '')}
            mb="md"
            size="md"
            radius="md"
            searchable
            dropdownPosition="bottom"
            withinPortal
          />
          <Button
            fullWidth
            size="md"
            radius="md"
            loading={shopifyLoading}
            onClick={handleShopifySubdomainConnect}
            styles={{ root: { backgroundColor: "black" } }}
          >
            Connect Store
          </Button>

          {/* Same status line as the website modal -- subdomain connect
              hits the same backend path so the timing concern is identical. */}
          {shopifyLoading && (
            <Text size="sm" color="dimmed" mt="md">
             Please wait while we complete the connection process. This may take 1–2 minutes.
            </Text>
          )}
        </div>
      </Modal>
      <Modal.Root size={1100} opened={addDomainOpened} onClose={closeDomainModal} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <VisiLoader VisiLoaderVisible={AddDomainLoader} />
          <VisiLoader VisiLoaderVisible={shopifySiteListLoader} />
          <VisiLoader VisiLoaderVisible={getSingleDomainLoader} />
          <Modal.Header>
            <Modal.Title>
              {domainModalStep === 'shopify_connect' ? (
                <Text></Text>
              ) : (
                <Text weight={500}>ADD A DOMAIN <IconHelp ref={addDomainIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(126); }} /></Text>
              )}
            </Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
            <Modal.Body>
              {domainModalStep === 'shopify_connect' ? (
              <div style={{ textAlign: 'center', padding: '20px 10px' }}>
              <Text size="lg" weight={600} mb={8}>
                Connect Your Shopify Store
              </Text>
              <Text size="sm" color="dimmed" mb={20}>
                Connect your Shopify store to start tracking data and managing campaigns seamlessly.
              </Text>
              <Button
                className="shopify-card__btn-connect"
                onClick={handleConnectShopifyStore}
                loading={shopifyLoading}
                style={{
                  display: 'block',
                  margin: '0 auto',
                  padding: '10px 30px'
                }}
              >
                Connect Shopify Store
              </Button>
            </div>
            ) : (
            <form onSubmit={(e) => handleAddDomainSubmit(e, FrontendFramework === '2' && !shopifyConnected)}>
              <Group mb={10}>
                <Text weight={500}>{publishToValue === '3' ? 'Subdomain Name:' : 'Website Name:'}</Text>
                <Input name="website_name" value={WebsiteName} onChange={(e) => setWebsiteName(e.target.value)} />
                <Text weight={500}>{publishToValue === '3' ? 'Subdomain Address:' : 'Website Address:'}</Text>
                {updateDomainId && updateDomainId > '0' ?
                  <Input name="website_address" value={WebsiteAddress} onChange={(e) => setWebsiteAddress(e.target.value)} />
                :
                  <Input name="website_address" value={WebsiteAddress} onChange={(e) => setWebsiteAddress(e.target.value)} />
                }
              </Group>
              <PermissionWrapper permission="add_domain_spa_frameworks_access">
                <Box mb={10}>
                  <Text weight={700} mb={5}>My website is built on:</Text>
                  <Radio.Group
                      name="frontend_framework"
                      value={FrontendFramework}
                      onChange={(e) => {
                        // Same guard as the subdomain edit form: while a
                        // Shopify install is connected to this website,
                        // refuse to switch the framework away from Shopify.
                        // The user must hit Disconnect Shopify (rendered
                        // alongside the form when shopifyConnected is true)
                        // before changing the framework.
                        if (updateDomainId && shopifyConnected && FrontendFramework === '2' && e !== '2') {
                          notifications.show({
                            color: 'yellow',
                            icon: <IconX size="1.1rem" />,
                            title: 'Disconnect Shopify first',
                            message: 'Please disconnect Shopify before changing the website framework.',
                          });
                          return;
                        }
                        if (e === '2' && updateDomainId) {
                          setShopifyStatusLoading(true);
                        }
                        setFrontendFramework(e);
                      }}
                      style={{ minWidth: 250, display: 'flex', flexDirection: 'column', gap: 5 }}
                    >
                      <Radio
                        value="0"
                        label={<span><span style={{fontWeight:500}}>HTML/PHP</span> <IconHelp ref={HTMLPHPRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(364); }} /></span>}
                      />
                      <Radio
                        value="1"
                        label={<span><span style={{fontWeight:500}}>Frontend Framework</span> <span style={{fontWeight:400, fontSize: '0.85rem'}}>(VueJs/ReactJs/AngularJs/NextJs)</span> <IconHelp ref={frontendframworkRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(365); }} /></span>}
                      />
                      {FrontendFramework === "1" && (
                        <Radio.Group
                          value={selectedFrameworkType}
                          onChange={(val) => setSelectedFrameworkType(val)}
                        >
                          <Box
                            ml={25}
                            mt={5}
                            mb={5}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: 20,
                              alignItems: "center"
                            }}
                          >
                            <Radio value="1" label="ReactJS" />
                            <Radio value="2" label="AngularJS" />
                            <Radio value="3" label="VueJS" />
                            <Radio value="4" label="NextJS" />
                            <Radio value="6" label="Astro" />
                            <Radio value="5" label="Other" />
                          </Box>
                        </Radio.Group>
                      )}
                      <Radio
                        value="3"
                        label={<span><span style={{fontWeight:500}}>GHL</span> <span style={{fontWeight:400, fontSize: '0.85rem'}}>(Go High Level)</span> <IconHelp ref={ghlRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(366); }} /></span>}
                      />
                      <Radio
                        value="2"
                        label={<span><span style={{fontWeight:500}}>Shopify</span> <IconHelp ref={shopifyRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(367); }} /></span>}
                      />
                      <Radio
                        value="4"
                        label={<span><span style={{fontWeight:500}}>WordPress</span> <IconHelp ref={wordpressRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(368); }} /></span>}
                      />
                      <Radio
                        value="5"
                        label={<span><span style={{fontWeight:500}}>EmDash CMS</span> <IconHelp ref={emdashRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(383); }} /></span>}
                      />
                    </Radio.Group>
                </Box>
              </PermissionWrapper>
              {/*THIS CODE IS NOT IN USE CURRENTLY*/}
{/*              <Group mb={10}>
                <Text weight={500}>I want to Publish to This Domain: </Text>
                <Checkbox onChange={handlePublishDomainChange} checked={PublishDomainChecked}/>
              </Group>
              {PublishDomainChecked ?
                <Group mb={10}>
                  <Text weight={500}>Choose Where You'd Like To Publish To: </Text>
                  <Radio.Group value={publishToValue} onChange={publishToSetValue}>
                    <Group>
                      <Radio value="1" label="Your Own Server" />
                      <Radio value="3" label="Visiopt Server Using a Custom Domain" />
                      <Radio value="2" label="Visiopt Server Using a Visiopt Subdomain" />
                    </Group>
                  </Radio.Group>
                </Box>
              : ""}
              {PublishDomainChecked && publishToValue && publishToValue === "1" ?
                <Group mb={10}>
                  <Box
                    mt={10}
                    sx={(theme) => ({
                      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : "#f8f9fa",
                      padding: "10px",
                      borderRadius: "4px"
                    })}
                  >
                  <Text weight={500}>ADDING FTP CREDENTIALS</Text>
                  <Space h="xs" />
                  <Text>Publishing directly to your own site is easy. Simply add your FTP details in the form provided.</Text>
                  <Space h="xs" />
                  <Text>Once you add your FTP details your site will be available for tracking and testing and it will also be available to publish to from Visiopt's Landing Page Module.</Text>
                  <Space h="xs" />
                  <Text><Text weight={500} component="span">Note: </Text>FTP details can be added at any time from the Website Edit Option.</Text>
                  <Space h="xs" />
                  <Text>If FTP doesn't connect be sure to check Protocol. FTP or SFTP as well as port.</Text>
                  <Space h="xs" />
                  <Text c="red" weight={500}>Some servers will not publish properly unless SFTP is used.</Text>
                </Box>
                <Group>
                  <Text weight={500}>Protocol : </Text>
                    <Select
                      data={[
                          { value: 'ftp', label: 'FTP' },
                          { value: 'sftp', label: 'SFTP' }
                        ]}
                      value={Protocol}
                      onChange={(e) => setProtocol(e)}
                      name="protocol"
                    />
                    <Text weight={500}>Host: </Text>
                    <Input name="host" value={Host} onChange={(e) => setHost(e.target.value)} />
                    <Text weight={500}>Port: </Text>
                    <Input name="port" value={Port} onChange={(e) => setPort(e.target.value)} />
                </Group>
                <Group>
                  <Text weight={500}>Username: </Text>
                    <Input name="username" value={Username} onChange={(e) => setUsername(e.target.value)} />
                    <Text weight={500}>Password: </Text>
                    <Input name="password" value={Password} onChange={(e) => setPassword(e.target.value)} />
                    <Text weight={500}>Default Root Directory: </Text>
                    <Input name="default_root_directory" value={DefaultRootDirectory} onChange={(e) => setDefaultRootDirectory(e.target.value)} />
                </Group>
                </Group>
              : ""}
              {PublishDomainChecked && publishToValue && publishToValue === "2" ?
                <Group mb={10}>
                  <Box
                    mt={10}
                    sx={(theme) => ({
                      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : "#f8f9fa",
                      padding: "10px",
                      borderRadius: "4px"
                    })}
                  >
                  <Text weight={500}>SIMPLE INSTRUCTIONS TO ADD YOUR DOMAIN</Text>
                  <Space h="xs" />
                  <Text>You will need to add a CNAME in your DNS records. This is quick and easy to do.</Text>
                  <Space h="xs" />
                  <Text>1. Choose the domain or subdomain you wish to use. You can use an entirely new domain or add a subdomain like... lp.mydomain.com or go.mydomain.com</Text>
                  <Space h="xs" />
                  <Text>2. Go to your DNS records.</Text>
                  <Space h="xs" />
                  <Text>3. Add the CNAME lp.visioptdev.com</Text>
                  <Space h="xs" />
                  <Text>4. Enter details as follows:</Text>
                  <Space h="xs" />
                  <Text><Text weight={500} component="span">TTL: </Text>3600</Text>
                  <Space h="xs" />
                  <Text><Text weight={500} component="span">Type: </Text>CNAME</Text>
                  <Space h="xs" />
                  <Text><Text weight={500} component="span">Record / Data/ Host: </Text>lp.visioptdev.com</Text>
                  <Space h="xs" />
                  <Text>5. You must wait until propagation before using this domain for publishing.</Text>
                  <Space h="xs" />
                  <Text>Check DNS Propogation here: <Anchor href="https://dnschecker.org/#CNAME/" target="_blank">https://dnschecker.org/#CNAME/</Anchor></Text>
                </Box>
                </Group>
              : ""}
              {PublishDomainChecked && publishToValue && publishToValue === "3" ?
                <Group mb={10}>
                  <Box
                    mt={10}
                    sx={(theme) => ({
                      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : "#f8f9fa",
                      padding: "10px",
                      borderRadius: "4px"
                    })}
                  >
                  <Text weight={500}>NOTES</Text>
                  <Space h="xs" />
                  <Text>Choose a unique subdomain not already in use. Please note we do recommend that you choose the Publish To Visiopt Servers Using a Custom Domain or Subdomain option for more privacy and better results.</Text>
                </Box>
                </Group>
              : ""}*/}
              {FrontendFramework === '2' && updateDomainId && updateDomainId > '0' && (shopifyStatusLoading || shopifyConnected || shopifyNeedsReauth) && (
                <Flex direction="column" justify="flex-start" mb={10}>
                  {shopifyStatusLoading ? (
                    <Skeleton height={36} width={140} radius="sm" />
                  ) : (
                    <>
                      <Group>
                        <Text fw={600}>
                          {`Connected to ${shopifyShopInput ? shopifyShopInput.replace('.myshopify.com', '') : 'Shopify Store'}`}
                        </Text>
                        <Button
                          type="button"
                          color="red"
                          loading={shopifyLoading}
                          onClick={executeShopifyDisconnect}
                          style={{ width: 120 }}
                        >
                          Disconnect
                        </Button>
                      </Group>
                      {/* Shopify has invalidated the refresh token -- only the merchant can fix it. */}
                      {shopifyNeedsReauth && (
                        <Text size="sm" color="red" mt={6}>
                          This Shopify connection needs to be re-authorized. Please reconnect the Visiopt app from your Shopify store.
                        </Text>
                      )}
                    </>
                  )}
                </Flex>
              )}
              <Group position="left">
                {updateDomainId && updateDomainId > '0' ?
                  <Button type="submit" >Update Domain</Button>
                :
                  <Button type="submit" >Add Domain</Button>
                }
                <Button color="red" type="button" onClick={closeDomainModal}>Cancel</Button>
              </Group>
            </form>
            )}
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
      <Modal.Root size="lg" opened={addSubdomainOpened} onClose={closeSubdomainModal} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <VisiLoader VisiLoaderVisible={getSubDomainListLoader} />
          <Modal.Header>
            <Modal.Title><Text weight={500}>{subdomainEditId ? 'EDIT SUBDOMAIN' : 'CONNECT A DOMAIN OR A SUBDOMAIN TO THE SITE'} <IconHelp ref={addSubdomainIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(160); }} /></Text></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
            <Modal.Body>
            {/*
              2-step subdomain modal, mirroring the website modal:
                Step 'subdomain'        -> framework selection + name + Add
                Step 'shopify_connect'  -> only the Connect Shopify Store CTA
              Step 2 only appears when Shopify was selected and Add succeeded.
            */}
            {subdomainModalStep === 'shopify_connect' ? (
              <div style={{ textAlign: 'center', padding: '20px 10px' }}>
                <Text size="lg" weight={600} mb={8}>
                  Connect Your Shopify Store
                </Text>
                <Text size="sm" color="dimmed" mb={20}>
                  Connect your Shopify store to start tracking data and managing campaigns seamlessly.
                </Text>
                <Button
                  className="shopify-card__btn-connect"
                  onClick={handleSubdomainConnectShopify}
                  style={{
                    display: 'block',
                    margin: '0 auto',
                    padding: '10px 30px'
                  }}
                >
                  Connect Shopify Store
                </Button>
              </div>
            ) : (
            <form onSubmit={handleAddSubdomainSubmit}>
              <PermissionWrapper permission="add_domain_spa_frameworks_access">
                <Box mb={10}>
                  <Text weight={700} mb={5}>My website is built on:</Text>
                  <Radio.Group
                      name="frontend_framework"
                      value={subdomainFrontendFramework}
                      onChange={(e) => {
                        // Guard: while a Shopify install is connected to this
                        // subdomain, refuse to switch the type away from
                        // Shopify -- silently letting it change would orphan
                        // the install on the merchant's store. The backend
                        // also enforces this; the frontend just shows a
                        // friendlier message before the user submits.
                        if (subdomainEditId && subdomainEditShopifyConnected && e !== '2') {
                          notifications.show({
                            color: 'yellow',
                            icon: <IconX size="1.1rem" />,
                            title: 'Disconnect Shopify first',
                            message: 'Please disconnect Shopify before changing the subdomain type.',
                          });
                          return;
                        }
                        setSubdomainFrontendFramework(e);
                      }}
                      style={{ minWidth: 250, display: 'flex', flexDirection: 'column', gap: 5 }}
                    >
                      <Radio
                        value="0"
                        label={<span><span style={{fontWeight:500}}>HTML/PHP</span> <IconHelp ref={HTMLPHPRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(364); }} /></span>}
                      />
                      <Radio
                        value="1"
                        label={<span><span style={{fontWeight:500}}>Frontend Framework</span> <span style={{fontWeight:400, fontSize: '0.85rem'}}>(VueJs/ReactJs/AngularJs/NextJs)</span> <IconHelp ref={frontendframworkRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(365); }} /></span>}
                      />
                      {subdomainFrontendFramework === "1" && (
                        <Radio.Group
                          value={subdomainSelectedFrameworkType}
                          onChange={(val) => setSubdomainSelectedFrameworkType(val)}
                        >
                          <Box
                            ml={25}
                            mt={5}
                            mb={5}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: 20,
                              alignItems: "center"
                            }}
                          >
                            <Radio value="1" label="ReactJS" />
                            <Radio value="2" label="AngularJS" />
                            <Radio value="3" label="VueJS" />
                            <Radio value="4" label="NextJS" />
                            <Radio value="6" label="Astro" />
                            <Radio value="5" label="Other" />
                          </Box>
                        </Radio.Group>
                      )}
                      <Radio
                        value="3"
                        label={<span><span style={{fontWeight:500}}>GHL</span> <span style={{fontWeight:400, fontSize: '0.85rem'}}>(Go High Level)</span> <IconHelp ref={ghlRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(366); }} /></span>}
                      />
                      <Radio
                        value="2"
                        label={<span><span style={{fontWeight:500}}>Shopify</span> <IconHelp ref={shopifyRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(367); }} /></span>}
                      />
                      <Radio
                        value="4"
                        label={<span><span style={{fontWeight:500}}>WordPress</span> <IconHelp ref={wordpressRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(368); }} /></span>}
                      />
                      <Radio
                        value="5"
                        label={<span><span style={{fontWeight:500}}>EmDash CMS</span> <IconHelp ref={emdashRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(383); }} /></span>}
                      />
                    </Radio.Group>
                </Box>
              </PermissionWrapper>
              <Group mb={10}>
                <Text weight={500}>Enter Domain/Subdomain Name: </Text>
                <Input name="domain_subdomain_name" w={260} value={subdomainName} onChange={(e) => setSubdomainName(e.target.value)}/>
                <Button type="submit" >{subdomainEditId ? 'Update' : 'Add'}</Button>
                {/* In edit mode, hide the table of existing rows -- the user
                    is focused on the single row they clicked, and seeing the
                    full list while editing one of them is confusing. */}
                {!subdomainEditId && (
                <Table striped highlightOnHover withBorder>
                  <tbody>
                    {subdomainTableData.map((item) => (
                      <tr key={item.domain_subdomain_id}>
                        <td>{item.domain_name}</td>
                        <td>
                          <Flex
                            justify="flex-end"
                            align="center"
                            direction="row"
                            wrap="wrap"
                          >
                            <ActionIcon
                              variant="default"
                              size="lg"
                              mx={3}
                              title="View UniversalSmart Code"
                              onClick={() => handleViewUniversalSmartCode(websiteId,item.domain_name,true,item.domain_subdomain_id)}
                            >
                              <IconCode size="1.1rem" />
                            </ActionIcon>
                            <ActionIcon
                              variant="default"
                              size="lg"
                              mx={3}
                              title="Edit"
                              onClick={() => handleEditSubdomain(item.domain_subdomain_id)}
                            >
                              <IconPencil size="1.1rem" />
                            </ActionIcon>
                            {/* Same warning the main domain shows: the token is still
                                stored, so only the status reveals a dead connection. */}
                            {Number(item.shopify_needs_reauth) === 1 && (
                              <Text size="xs" color="red" mx={3}>
                                Reconnect Shopify
                              </Text>
                            )}
                            {Number(item.is_shopify_connected) === 1 && (
                              <ActionIcon
                                variant="default"
                                size="lg"
                                mx={3}
                                title="Disconnect Shopify"
                                onClick={() => handleSubdomainDisconnectShopify(item.domain_subdomain_id, item.domain_name)}
                              >
                                <IconUnlink size="1.1rem" />
                              </ActionIcon>
                            )}
                            <ActionIcon
                              variant="default"
                              size="lg"
                              title="Delete"
                              onClick={() => deleteSubdomainConfirm(item.domain_subdomain_id,item.domain_name)}
                            >
                              <IconX size="1.1rem" />
                          </ActionIcon>
                          </Flex>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                )}
              </Group>
            </form>
            )}
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
      <Group position="apart" mt="md" mb="xs">
        <Text weight={500}>MANAGE YOUR DOMAINS <IconHelp ref={manageDomainIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={(e:any) => { e.stopPropagation(); e.preventDefault(); handleHelpClick(172); }} /></Text>
      </Group>
      <Button onClick={() => checkAddDomain()}>
        Add a New Domain
      </Button>
      {DomainList.length > 0 && (
        <Box
          p={4}
          pl={20}
          mt={10}
          sx={(theme) => ({
            padding: "10px",
            borderRadius: theme.radius.md,
            fontWeight: "bold",
          })}
        >
        {DomainList.some(item => Array.isArray(item) ? item.length > 0 : true) && (
          <Flex justify="space-between" align="center" style={{ width: "100%" }}>
            <Text mt={3} weight={500} onClick={() => handleSorting('website_name')}>
              <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
                {'Website Name'}
                {sortKeyName === 'website_name' && (
                  sortingDirection === 'asc' ? <IconCaretUpFilled /> : <IconCaretDownFilled />
                )}
              </span>
            </Text>
            <Input icon={<IconSearch size={16} />} 
              placeholder="Search"
              maxLength={50}
              autoFocus
              onChange={handleKeywordChange}
              style={{ maxWidth: "250px" }}
            />
          </Flex>
        )}
        </Box>
      )}
      {sortedDomainList.map((Domain, DomainIndex) =>
        <Box
          key={DomainIndex}
          p={4}
          pl={20}
          mt={10}
          sx={(theme) => ({
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : '#f8f9fa',
            padding: "10px",
            borderRadius: theme.radius.md,
            border: "0.0625rem solid transparent",
            borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[1] : '#dee2e6'
          })}
        >
          <Grid gutter="xs">
            <Grid.Col span={6}>
              <Link to={Domain.website_url} target="_blank" style={{ textDecoration: 'none', color: colorTheme === "light" ? "black" : "white" }}>
                {Domain.website_name}
              </Link>
            </Grid.Col>
            <Grid.Col span={6}>
              <Flex
                justify="flex-end"
                align="center"
                direction="row"
                wrap="wrap"
                gap={2}
              >              
              <ActionIcon
                variant="default"
                size="lg"
                mx={3}
                title="View UniversalSmart Code"
                onClick={() => handleViewUniversalSmartCode(Domain.website_id, Domain.website_url)}
              >
                <IconCode size="1.1rem" />
              </ActionIcon>
              <ActionIcon
                variant="default"
                size="lg"
                mx={3}
                title="Flicker Settings"
                onClick={() => handleFlickerSettings(Domain.website_id)}
              >
                <IconSettings size="1.1rem" />
              </ActionIcon>
              <ActionIcon
                variant="default"
                size="lg"
                mx={3}
                title="Edit"
                onClick={() => updateDomain(Domain.website_id)}
              >
                <IconPencil size="1.1rem" />
              </ActionIcon>
              <ActionIcon
                variant="default"
                size="lg"
                mx={3}
                title="Add Subdomain"
                onClick={() => AddSubdomain(Domain.website_id)}
              >
                <IconWorld size="1.1rem" />
              </ActionIcon>
              <ActionIcon
                variant="default"
                size="lg"
                mx={3}
                title="Delete"
                onClick={() => deleteDomainConfirm(Domain.website_id)}
              >
                <IconTrash size="1.1rem" />
              </ActionIcon>
              </Flex>
            </Grid.Col>
          </Grid>
        </Box>
      )}
      <UniversalSmartCodeModal
        opened={visiSmartCodeModalOpen}
        onClose={handleCloseVisiSmartCodeModal}
        websiteId={visiSmartCodeWebsiteId}
        websiteUrl={visiSmartCodeWebsiteUrl}
        subdomainVisiSmartCode={subdomainVisiSmartCode}
        visiSmartCodeSubdomainId={visiSmartCodeSubdomainId}
        showShopifyConfirmationCode={false}
      />
      {flickerSettingsModelOpen && (
        <DomainFlickerSettings
          websiteId={flickerSettingsWebsiteId}
          settingModalOpen={flickerSettingsModelOpen}
          handleSettingCloseModal={handleFlickerSettingsClose}
        />
      )}
		</>
	);
}
